import { render, staticRenderFns } from "./UiKit.vue?vue&type=template&id=99a6f690&"
import script from "./UiKit.vue?vue&type=script&lang=js&"
export * from "./UiKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a6f690')) {
      api.createRecord('99a6f690', component.options)
    } else {
      api.reload('99a6f690', component.options)
    }
    module.hot.accept("./UiKit.vue?vue&type=template&id=99a6f690&", function () {
      api.rerender('99a6f690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/UiKit.vue"
export default component.exports